// extracted by mini-css-extract-plugin
module.exports = {"slider":"Slider_slider__Grvko","noGutter":"Slider_noGutter__twVta"};